import React from "react";
import "../style/Card.css";

const Card = ({ img, title, category, time }) => {
  return (
    <div className="Card">
      <img className="imgCard" src={img} alt="" />
      <div className="contentCard">
        <div className="titleCard">
          <div>
            <h4>{title}</h4>
            <p>
              Категорија:<span>{category}</span>
            </p>
          </div>
          <div className="circle">
            <div className="circle-img">
              <img className="" src={img} alt="" />
            </div>
          </div>
        </div>
        <div className="durationCard">
          <i className="fa fa-clock-o fa-lg" aria-hidden="true"></i>
          <div>
            <h4>Времетраење</h4>
            <p>{time}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
